module.exports = __webpack_public_path__ + "static/img/mobile_app_analysisi.fa963722.jpg";